// var Index_tab_featured_collection_slider = new Swiper(".Index_tab_featured_collection_slider", {
//     slidesPerView: 'auto',
//     spaceBetween: 16,
//     direction: "horizontal",
//     mousewheel: {
//         forceToAxis: true,
//     },
//     breakpoints: {
//         0: {
//             spaceBetween: 16,
//         },
//         750: {
//             spaceBetween: 0,
//         },
//         990: {
//             spaceBetween: 8,
//         },
//         1440: {
//             spaceBetween: 16,
//         }
//     }
// });

// let isInitialLoad = true;
// const collection_tabs = document.querySelectorAll(".Index_featrued_collection_single_tab");
// const collection_tab_sliders = document.querySelectorAll(".Index_tab_featured_collection_slider")

// collection_tabs.forEach(collection_tab => {
//     collection_tab.addEventListener('click', function() {
//         collection_tabs.forEach(t => t.classList.remove("active"));
//         this.classList.add("active");
//         if (!isInitialLoad) {
//             this.scrollIntoView({
//                 behavior: "smooth",
//                 inline: "center",
//                 block: "nearest"
//             });
//         }
//         const data_collection_tab = this.dataset.collectionTab;
//         collection_tab_sliders.forEach(collection_tab_slider => {
//             const data_collection_slider = collection_tab_slider.dataset.collectionSlider;
//             if(data_collection_tab == data_collection_slider) {
//                 collection_tab_slider.classList.add("show")
//             }
//             else {
//                 collection_tab_slider.classList.remove("show")
//             }
//         })
//     })
// });

// const firstTab = document.querySelector(".Index_featrued_collection_single_tab:first-child");
// if (firstTab) {
//   firstTab.click();
// }
// isInitialLoad = false;




var Index_tab_featured_collection_slider = new Swiper(".Index_tab_featured_collection_slider", {
    slidesPerView: 'auto',
    spaceBetween: 16,
    direction: "horizontal",
    mousewheel: {
        forceToAxis: true,
    },
    breakpoints: {
        0: {
            spaceBetween: 16,
        },
        750: {
            spaceBetween: 0,
        },
        990: {
            spaceBetween: 8,
        },
        1440: {
            spaceBetween: 16,
        }
    }
});

let isInitialLoad = true;
const collection_tabs = document.querySelectorAll(".Index_featrued_collection_single_tab");
const collection_tab_sliders = document.querySelectorAll(".Index_tab_featured_collection_slider")

collection_tabs.forEach(collection_tab => {
    collection_tab.addEventListener('click', function() {
        collection_tabs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");
        if (!isInitialLoad) {
            this.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest"
            });
        }
        const data_collection_tab = this.dataset.collectionTab;
        collection_tab_sliders.forEach(collection_tab_slider => {
            const data_collection_slider = collection_tab_slider.dataset.collectionSlider;
            if(data_collection_tab == data_collection_slider) {
                collection_tab_slider.classList.add("show")
            }
            else {
                collection_tab_slider.classList.remove("show")
            }
        })
    })
});

const firstTab = document.querySelector(".Index_featrued_collection_single_tab:first-child");
if (firstTab) {
  firstTab.click();
}

isInitialLoad = false;

